module.exports = __webpack_public_path__ + "img/768_banner_2.6c4bd669.jpg";